import { AbstractBlock } from '../AbstractBlock';
import { ShapeSettings } from '../setting/ShapeSettings';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const t = block_translation;

const Blockly = GlobalImport.getBlockly();

export class AnyAssets extends AbstractBlock {
  constructor() {
    super('any_assets', t.to('汎用アセット', 'general_asset'));
  }

  defineBlock(block: BlockType): void {
    ShapeSettings.setElementWithSubBlockShape(block);
    ColorSettings.setAnyColor(block);
    ShapeSettings.setTitleField(block, t.to('汎用アセット', 'general_asset'));

    const asset_type = ShapeSettings.getDropDown([
      ['a-asset-item', 'a-asset-item'],
      ['audio', 'audio'],
      ['img', 'img'],
      ['video', 'video'],
    ]);
    block.appendDummyInput().appendField(`type:`).appendField(asset_type, 'asset_type');

    const id = new Blockly.FieldTextInput('');
    block.appendDummyInput().appendField(`id:`).appendField(id, 'id');

    const path = new Blockly.FieldTextInput('');
    block
      .appendDummyInput()
      .appendField(t.to(`アセットパス`, 'asset_path') + ':')
      .appendField(path, 'path');

    ShapeSettings.addAttributeInput(block);
  }

  generateAssetsHTMLCode(block: BlockType): string {
    const type = CodeSetting.getFieldValue(block, 'asset_type');
    const path = CodeSetting.getFieldValue(block, 'path');
    const id = CodeSetting.getFieldValue(block, 'id');
    const src = `<${type} id="${id}" src="${path}"></${type}>`;
    return src;
  }
}
